export default __webpack_public_path__ + "static/media/success.854f5e1c.png";